module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand15-075ac52dd23b7aeb0594fc6b24601d5a.jpg";